import { Color, TypographyColor, colorOptions } from "../components/typography"
import Typography, { TypographyElement } from "../Typography"

import React from "react"
import { types } from "react-bricks/frontend"

export interface DecorativeTextProps {
    text: TypographyElement[]
    color?: { color: TypographyColor } | TypographyColor
    index?: number
}

const DecorativeText: types.Brick<DecorativeTextProps> = ({ color, index }) => {
    const txtColor = typeof color === "object" ? color.color : color

    return (
        <div key={index}>
            <div className="inline-block rounded-base border border-solid border-border-tide p-5 sm:rounded-lg lg:p-7.5">
                <Color color={txtColor}>
                    <Typography allowList={["big", "sup", "link"]} />
                </Color>
            </div>
        </div>
    )
}

DecorativeText.schema = {
    name: "DecorativeText",
    label: "Decorative Text",
    hideFromAddMenu: true,
    sideEditProps: [
        {
            name: "color",
            label: "Color",
            type: types.SideEditPropType.Select,
            selectOptions: {
                options: colorOptions,
                display: types.OptionsDisplay.Color,
            },
        },
    ],
    getDefaultProps: (): DecorativeTextProps => ({
        color: TypographyColor.Darkgrey,
        text: [
            {
                type: "paragraph",
                children: [
                    {
                        text: "Lorem ",
                    },
                    {
                        text: "ipsum",
                        big: true,
                    },
                    {
                        text: " dolor",
                    },
                ],
            },
        ],
    }),
}

export default DecorativeText
